import React from 'react';
import {
  StaticInstallmentsDescription,
  StaticInstallmentsDescriptionProps,
} from '../controller';
import { PaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';
import { MoreInfoIframe } from '../MoreInfoIframe';
import { AfterpayCurrencySymbol, AFTERPAY_COUNTRIES } from '../constants';
import { buildAfterpayClearpayModalUrl } from '../utils';

export const INSTALLMENTS_NUMBER = 4;
export const INFO_MODAL_SIZE = {
  width: 780,
  height: 627,
};

export interface AfterpayDescriptionProps
  extends Omit<
    StaticInstallmentsDescriptionProps,
    'methodName' | 'intallmentsNumber' | 'moreInfo'
  > {
  country?: string;
}

export const AfterpayDescription: React.FunctionComponent<AfterpayDescriptionProps> =
  ({ deviceType, amount, currency, country, isSinglePaymentMethodOption }) => {
    const isCountrySupported = AFTERPAY_COUNTRIES.includes(country);
    const currencySymbol = AfterpayCurrencySymbol[currency];

    if (!isCountrySupported || !currencySymbol) {
      return null;
    }

    const infoModalUrl = buildAfterpayClearpayModalUrl(country);

    const moreInfoContent = infoModalUrl && (
      <MoreInfoIframe src={infoModalUrl} deviceType={deviceType} />
    );

    return (
      <StaticInstallmentsDescription
        deviceType={deviceType}
        methodName={PaymentMethod.Afterpay}
        amount={amount}
        currency={currencySymbol}
        intallmentsNumber={INSTALLMENTS_NUMBER}
        moreInfo={moreInfoContent}
        moreInfoSize={INFO_MODAL_SIZE}
        isSinglePaymentMethodOption={isSinglePaymentMethodOption}
      />
    );
  };
AfterpayDescription.displayName = 'AfterpayDescription';
